import * as React from 'react';
import SwiperCore from 'swiper';

import { SwiperCarousel } from '../../components/SwiperCarousel';
import { CLASS_NAME_CAROUSEL_END, SWIPER_OPTIONS } from '../../constants/pikPlus';

interface IPikPlusCarouselProps {
  children: React.ReactElement[];
}

export function PikPlusCarousel({ children }: IPikPlusCarouselProps) {
  const swiperChangeHandle = (swiper: SwiperCore) => {
    if (children.length === swiper.realIndex + Math.floor(SWIPER_OPTIONS.slidesPerView)) {
      swiper.$el.addClass(CLASS_NAME_CAROUSEL_END);
    } else if (swiper.$el.hasClass(CLASS_NAME_CAROUSEL_END)) {
      swiper.$el.removeClass(CLASS_NAME_CAROUSEL_END);
    }
  };

  return (
    <SwiperCarousel className="pik-plus-carousel" onSlideChange={swiperChangeHandle} {...SWIPER_OPTIONS}>
      {children}
    </SwiperCarousel>
  );
}
